"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const next12_components_custom_link_1 = __importDefault(require("@gcloud-npm/next12.components.custom-link"));
const next12_components_text_info_n_1 = __importDefault(require("@gcloud-npm/next12.components.text-info-n"));
const next12_utils_enums_colors_1 = __importDefault(require("@gcloud-npm/next12.utils.enums.colors"));
const next12_components_icon_n_1 = __importDefault(require("@gcloud-npm/next12.components.icon-n"));
const components_icon_glyph_1 = __importDefault(require("@gcloud-npm/components.icon-glyph"));
const react_redux_1 = require("react-redux");
const next12_app_controller_reducers_sagas_modals_reducer_1 = require("@gcloud-npm/next12.app-controller.reducers-sagas.modals-reducer");
const next12_utils_common_1 = require("@gcloud-npm/next12.utils.common");
const utils_common_telco_logout_1 = require("@gcloud-npm/utils.common.telco-logout");
const menu_1 = __importDefault(require("../../menu"));
const close_button_1 = __importDefault(require("../close-button"));
class UserModal extends react_1.Component {
    constructor(props) {
        super(props);
        this.drawModal = (device) => {
            try {
                if (device && device === "mobile") {
                    const modalParent = document.querySelector(".modal-root");
                    modalParent.style.zIndex = "35";
                    modalParent.style.height = "100vh";
                    modalParent.style.top = "0px";
                    const modalContent = document.querySelector(".Modal_content");
                    modalContent.classList.add("modal-scroll-hidden");
                }
                else {
                    const positiontop = document.querySelector(".header .header1-main").clientHeight;
                    const modalParent = document.querySelector(".modal-root");
                    modalParent.style.zIndex = "35";
                    modalParent.style.height = `calc(100vh - ${parseInt(positiontop, 10)}px)`;
                    modalParent.style.top = `${parseInt(positiontop, 10) - 1}px`;
                    document.querySelector(".header-modal-user").style.boxShadow = "none";
                }
            }
            catch (err) {
                console.error(err);
            }
        };
        this.closeModal = () => {
            const { addModal } = this.props;
            addModal({
                id: "closeAll",
            });
        };
        this.setDevice = () => {
            const device = (0, next12_utils_common_1.getDeviceKindDependsOnViewPort)();
            this.setState({ device });
        };
        this.state = {
            device: null,
        };
    }
    componentDidMount() {
        this.setDevice();
        this.drawModal();
        window.addEventListener("resize", this.setDevice);
    }
    shouldComponentUpdate(nextProps, nextState) {
        const { device } = this.state;
        const { device: nextDevice } = nextState;
        const shouldRender = device !== nextDevice;
        if (shouldRender) {
            this.drawModal(nextDevice);
        }
        return shouldRender;
    }
    componentWillUnmount() {
        window.removeEventListener("resize", this.setDevice);
        const modalParent = document.querySelector(".modal-root");
        modalParent.style.removeProperty("z-index");
        modalParent.style.removeProperty("top");
        modalParent.style.removeProperty("height");
        const modalContent = document.querySelector(".Modal_content");
        modalContent.classList.remove("modal-scroll-hidden");
    }
    render() {
        const { userName, items, userType } = this.props;
        const colorBlue = (0, next12_utils_enums_colors_1.default)("BLUE");
        const colorGrey1 = (0, next12_utils_enums_colors_1.default)("GREY1");
        return (react_1.default.createElement("div", { className: "header-modal-user" },
            react_1.default.createElement("div", { className: "close" },
                react_1.default.createElement(close_button_1.default, { onClick: this.closeModal, color: colorBlue, backgroundColor: "transparent", onHoverColor: colorGrey1, taggingInfo: {
                        componentName: "header",
                        componentContent: "closeAccount",
                        componentVariation: "all",
                        componentPerso: "",
                        componentProduct: "",
                    } })),
            react_1.default.createElement("div", { className: "user-pill" },
                react_1.default.createElement("div", { className: "user-icon" },
                    react_1.default.createElement(next12_components_icon_n_1.default, { id: "Usuario", color: "white", size: 20, kind: "M" })),
                react_1.default.createElement("div", { className: "user-content" },
                    react_1.default.createElement(next12_components_text_info_n_1.default, { text: userName || "", fontType: "font-regular", size: "title06", color: "grey6", display: "block" }),
                    react_1.default.createElement("div", { className: "user-menu" },
                        react_1.default.createElement("div", { className: "item" },
                            react_1.default.createElement(next12_components_text_info_n_1.default, { text: "Titular de la cuenta", fontType: "font-regular", size: "title06", color: "grey5", display: "inline" }))))),
            react_1.default.createElement("div", { className: "sections" },
                react_1.default.createElement(menu_1.default, { items: items, layout: "default" })),
            react_1.default.createElement("div", { className: "exit" },
                react_1.default.createElement(next12_components_custom_link_1.default, { internal: true, onClick: () => (0, utils_common_telco_logout_1.logoutFromMovistar)({ userType }), title: "Cerrar sesi\u00F3n", ariaLabel: "Cerrar sesi\u00F3n", taggingInfo: {
                        componentName: "header",
                        componentContent: "menu",
                        componentVariation: "all",
                        componentPerso: "",
                        componentProduct: "",
                    } },
                    react_1.default.createElement("div", { className: "menu-item exit" },
                        react_1.default.createElement("div", { className: "text-gap" },
                            react_1.default.createElement("div", { className: "icon-gap" },
                                react_1.default.createElement(components_icon_glyph_1.default, { color: "grey5", width: "16px", height: "29px", kind: "m", id: "logout" })),
                            react_1.default.createElement(next12_components_text_info_n_1.default, { text: "Cerrar sesi\u00F3n", align: "center", fontType: "font-regular", size: "caption01", color: "grey5", display: "inline" })))))));
    }
}
const mapStateToProps = (state) => ({});
const mapDispatchToProps = (dispatch) => ({
    addModal: (data) => dispatch(next12_app_controller_reducers_sagas_modals_reducer_1.actions.addModal(data)),
});
exports.default = (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps)(UserModal);
//# sourceMappingURL=index.js.map